import { IGetValueArgs } from "@components/smart/FieldInfo";
import {
    ChartOfAccountsTemplateEntity,
    EntitySetName,
    IAccountEntity,
    IChartOfAccountsTemplateEntity
} from "@odata/GeneratedEntityTypes";
import { AccountingCode } from "@odata/GeneratedEnums";
import { OData } from "@odata/OData";
import { CategoryItems, IChartOfAccountsFormCustomData } from "@pages/chartOfAccounts/ChartOfAccounts.utils";
import { isNonProfitCompany } from "@utils/CompanyUtils";
import { logger } from "@utils/log";

import { FormStorage } from "../../views/formView/FormStorage";

async function getTemplateNames(oData: OData, accCode: AccountingCode): Promise<IChartOfAccountsTemplateEntity[]> {
    try {
        const query = oData.getEntitySetWrapper(EntitySetName.ChartOfAccountsTemplates)
            .query()
            .filter(`${ChartOfAccountsTemplateEntity.AccountingCode} eq '${accCode}'`)
            .select(ChartOfAccountsTemplateEntity.Name);

        const result = await query.fetchData<IChartOfAccountsTemplateEntity[]>();
        // returns template names with ids
        return result.value;
    } catch (error) {
        logger.error("Error fetching chart of accounts template names:", error);
        return null;
    }
}

export const getUniqName = async (oData: OData, name: string, accCode: AccountingCode): Promise<string> => {
    const templates = await getTemplateNames(oData, accCode);
    const names = templates?.map(item => item.Name);

    // replace previous number if present
    name = name.replace(/\W\([0-9]+\)$/, "");

    let newName = name;
    let i = 1;
    while (names?.includes(newName)) {
        newName = `${name} (${i})`;
        ++i;
    }
    return newName;
};

export const isNonProfitCompanyWithTemplateFallback = (args: IGetValueArgs): boolean => {
    const hasCompany = !!args.context.getCompany();
    if (hasCompany) {
        return isNonProfitCompany(args.context);
    }

    const accCode = (args.storage as FormStorage<IAccountEntity, IChartOfAccountsFormCustomData>).getCustomData().accountingCode;
    return accCode === AccountingCode.AccountingForNonprofitOrganizations;
};

export function isIncomeStatementCategory(cat: string): boolean {
    return [CategoryItems.IncomeStatementActive, CategoryItems.IncomeStatementExpense,
        CategoryItems.IncomeStatementActiveTaxable, CategoryItems.IncomeStatementExpenseTaxable].includes(cat as CategoryItems);
}